import React from "react";
import { Title } from "../../components/Title";
import "./styles.less";
import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";

export const PriceMessage = () => {
  const { t } = useTranslation();
  return (
    <div className="price-message">
      <section className="message-advance">
        <div className="inner">
          <div className="top">
            <div>
              <Title title={t("price.guide.title")}>{t("price.guide.subtitle")}</Title>
            </div>
          </div>
          <div className="button-warp">
            <Button
              onClick={() => {
                window.open("//files.authing.co/authing-website/%E6%9E%84%E5%BB%BA%20vs%20%E8%B4%AD%E4%B9%B0.pdf");
              }}
            >
              {t("price.guide.button")}
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};
